export class GeographicFilterRegionModel {
  private _fieldDivisionID: string;
  private _fieldDivisionName: string;

  private _stateID: string;
  private _stateName: string;

  private _countyID: string;
  private _countyName: string;
  private _counties: ServerModels.ENESS_REF_Counties[] = [];
  private _countyNameList: string;
  private _countiesTotalCount: number;

  private _fdgroupID: string;
  private _fdgroupName: string;
  private _fdgroups: ServerModels.FieldDivisionGroupViewModel[] = [];
  private _fdgroupNameList: string;
  private _fdgroupsTotalCount: number;
  

  private _agencyID: string;
  private _agencyName: string;
  private _agencies: ServerModels.AgencyViewModel[] = [];
  private _agencyNameList: string;
  private _agenciesTotalCount: number;

  constructor(fieldDivisionID: string, stateID: string, countyID: string, counties: ServerModels.ENESS_REF_Counties[], fieldDivisionName: string, stateName: string, countyName: string, countyNamesList: string, agencyID: string, agencyName: string, agenciesNameList: string, agencies: ServerModels.AgencyViewModel[], fdgroupID: string, fdgroupName: string, fdgroupNameList: string, fdgroups: ServerModels.FieldDivisionGroupViewModel[]) {
    this._fieldDivisionID = fieldDivisionID;
    this._fieldDivisionName = fieldDivisionName;

    this._stateID = stateID;
    this._stateName = stateName;

    this._countyID = countyID;
    this._counties = counties;
    this._countyName = countyName;
    this._countyNameList = countyNamesList;

    this._agencyID = agencyID;
    this._agencyName = agencyName;
    this._agencyNameList = agenciesNameList;
    this._agencies = agencies;

    this._fdgroupID = fdgroupID;
    this._fdgroupName = fdgroupName;
    this._fdgroups = fdgroups;
    this._fdgroupNameList = fdgroupNameList;

  }

  get fieldDivisionID(): string {
    return this._fieldDivisionID;
  }

  set fieldDivisionID(id: string) {
    this._fieldDivisionID = id;
  }

  get fieldDivisionName(): string {
    return this._fieldDivisionName;
  }

  set fieldDivisionName(fd: string) {
    this._fieldDivisionName = fd;
  }

  get stateID(): string {
    return this._stateID;
  }

  set stateID(id: string) {
    this._stateID = id;
  }

  get stateName(): string {
    return this._stateName;
  }

  set stateName(state: string) {
    this._stateName = state;
  }

  get countyID(): string {
    return this._countyID;
  }

  set countyID(id: string) {
    this._countyID = id;
  }

  get countyName(): string {
    return this._countyName;
  }

  set countyName(county: string) {
    this._countyName = county;
  }

  get countyNameList(): string {
    return this._countyNameList;
  }

  set countyNameList(countyNames: string) {
    this._countyNameList = countyNames;
  }

  get countiesTotalCount(): number {
    return this._countiesTotalCount;
  }

  set countiesTotalCount(count: number) {
    this._countiesTotalCount = count;
  }

  get counties(): ServerModels.ENESS_REF_Counties[] {
    return this._counties;
  }

  set counties(counties: ServerModels.ENESS_REF_Counties[]) {
    this._counties = counties;
  }

  get agencyID(): string {
    return this._agencyID;
  }

  set agencyID(id: string) {
    this._agencyID = id;
  }

  get agencyName(): string {
    return this._agencyName;
  }

  set agencyName(name: string) {
    this._agencyName = name;
  }

  get agenciesNameList(): string {
    return this._agencyNameList;
  }

  set agenciesNameList(agenciesNames: string) {
    this._agencyNameList = agenciesNames;
  }

  get agenciesTotalCount(): number {
    return this._agenciesTotalCount;
  }

  set agenciesTotalCount(count: number) {
    this._agenciesTotalCount = count;
  }

  get agencies(): ServerModels.AgencyViewModel[] {
    return this._agencies;
  }

  set agencies(agency: ServerModels.AgencyViewModel[]) {
    this._agencies = agency;
  }

  get fdgroupID(): string {
    return this._fdgroupID;
  }

  set fdgroupID(id: string) {
    this._fdgroupID = id;
  }

  get fdgroupName(): string {
    return this._fdgroupName;
  }

  set fdgroupName(group: string) {
    this._fdgroupName = group;
  }

  get fdgroupNameList(): string {
    return this._fdgroupNameList;
  }

  set fdgroupNameList(fdgroupNames: string) {
    this._fdgroupNameList = fdgroupNames;
  }

  get fdgroupsTotalCount(): number {
    return this._fdgroupsTotalCount;
  }

  set fdgroupsTotalCount(count: number) {
    this._fdgroupsTotalCount = count;
  }

  get fdgroups(): ServerModels.FieldDivisionGroupViewModel[] {
    return this._fdgroups;
  }

  set fdgroups(fdgroups: ServerModels.FieldDivisionGroupViewModel[]) {
    this._fdgroups = fdgroups;
  }

}
